import { twMerge } from "tailwind-merge";

export const TrustPolicy = (props) => {
  if(props.title?.trim()?.length == 0 && props.icon?.trim()?.length == 0) return null;

  return (
    <div 
      class={twMerge(
        "flex gap-2 overflow-x-scroll scrollbar-hide sm:overflow-x-scroll justify-center",
        props.class ?? ''
      )}
      classList={{
        "pb-2": props.isNewVersion
      }}
      id="rtb-icons-template--20286270636278__product_hero_classic_flat_pGkGgd">

      <p class="border-secondary-600 md:flex-1 md:py-0.5 py-[2px] swiper-slide swiper-slide-active text-2xs trust-policy whitespace-nowrap"
        role="group" aria-label="2 / 4" data-swiper-slide-index="1" style="width: 343px;">
        <span class="flex items-center gap-0.5 justify-center h-full font-bold"> 
          <span class="w-3 h-3 sm:w-4 sm:h-4 grid items-center" innerHTML={props.icon} />

          {props.title}
        </span>
      </p>
    </div>
  )
}